/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
import{ReloadableShaderModule as e}from"../core/shaderTechnique/ReloadableShaderModule.js";import{DefaultMaterialTechnique as r}from"./DefaultMaterialTechnique.js";import{R as s}from"../../../../chunks/RealisticTree.glsl.js";class i extends r{constructor(r,i){super(r,i,new e(s,(()=>import("./RealisticTree.glsl.js")))),this.type="RealisticTreeTechnique"}}export{i as RealisticTreeTechnique};
